import React from "react";

const priotityInstitutes = ["PRXBGRAA", "PIRAEUS_PIRBGRAA", "EUROBANK_ERGASIAS_ERBKGRAA", "NBG_ETHNGRAAXXX",
    "ALPHABANK_CRBAGRAA", "ATTICA_ATTIGRAA", "OPTIMA_IBOGGRAA", "REVOLUT_REVOLT21"];

const instituteImages = [
    {id: "PRXBGRAA", path: "assets/images/banks/viva.png"},
    {id: "PIRAEUS_PIRBGRAA", path: "assets/images/banks/piraeus.png"},
    {id: "EUROBANK_ERGASIAS_ERBKGRAA", path: "assets/images/banks/eurobank.png"},
    {id: "NBG_ETHNGRAAXXX", path: "assets/images/banks/nbg.png"},
    {id: "ALPHABANK_CRBAGRAA", path: "assets/images/banks/alphabank.png"},
    {id: "ATTICA_ATTIGRAA", path: "assets/images/banks/attica.png"},
    {id: "OPTIMA_IBOGGRAA", path: "assets/images/banks/optima.png"},
    {id: "REVOLUT_REVOLT21", path: "assets/images/banks/revolut.png"},
]

export const constructInstitutesOptions = (institutes = [], permissionsData) => {
    return institutes.map((o) => {
        const matchingImage = instituteImages.find((el) => el.id === o.id);
        if (matchingImage) {
            return {
                value: o.id,
                label: <React.Fragment><img src={matchingImage.path} alt={`logo_${o.id}`} width={"20px"} className={"mr-2"} key={`logo_${o.id}`} /> {o.name}</React.Fragment>,
            }
        } else {
            return {
                value: o.id,
                label: o.name,
            }
        }
    }).filter((el) => {
        if (permissionsData?.some((el) => el.permissionName === "custom-vivabank")) {
            if (el.value === "PRXBGRAA") {
                return el;
            } else {
                return null;
            }
        }
        return el;
    }).filter(Boolean).slice().sort((a, b) => {
        const indexA = priotityInstitutes.indexOf(a.value);
        const indexB = priotityInstitutes.indexOf(b.value);

        const aInOrder = indexA !== -1;
        const bInOrder = indexB !== -1;

        if (aInOrder && bInOrder) return indexA - indexB;
        if (aInOrder) return -1; // a comes first
        if (bInOrder) return 1;  // b comes first
        return 0; // both not in order, maintain their relative order
    });
}